export function close_menu()
{
	const menuTrigger = document.querySelector('.menu-trigger');
	let body = document.querySelector('body');
	if (body.classList.contains('menu-active')) {
		menuTrigger.click();
	}
}

/**
 * Sets up a click event
 */
export function setup_menu_trigger()
{
	const menuTrigger = document.querySelector('.menu-trigger');

	if (!menuTrigger) return;

	const buttonText = menuTrigger.innerHTML;
	const buttonIcon = menuTrigger.getAttribute('data-icon');

	menuTrigger.addEventListener('click', function (e)
	{
		e.preventDefault();
		let body = document.querySelector('body');

		if (body.classList.contains('contact-menu-active'))
		{
			body.classList.remove('contact-menu-active');
		}

		if (body.classList.contains('menu-active'))
		{
			body.classList.remove('menu-active');
			menuTrigger.innerHTML = buttonText;
		} else
		{
			body.classList.add('menu-active');
			menuTrigger.innerHTML = `
				<svg class="${ buttonIcon }" height="24" width="24">
					<use xlink:href="#${ buttonIcon }" />
				</svg>
			`;
		}
	});

	const nav = document.querySelector('.mobilemenu__lockup');

	if (nav)
	{
		nav.addEventListener('click', function (e)
		{
			if (e.target.tagName === 'A' && e.target.closest('.mobilemenu__lockup'))
			{
				const body = document.querySelector('body');
				body.classList.remove('menu-active');
				menuTrigger.innerHTML = buttonText;
			}
		});
	}
}

export function reset_menu_trigger()
{
	const nav = document.querySelector('.mobilemenu__lockup');

	const accordionBodies = nav.querySelectorAll('[data-accordion-body]');
	const accordionButtons = nav.querySelectorAll('[data-accordion-button]');

	accordionBodies.forEach(body =>
	{
		body.classList.remove('expanded');
		body.style.maxHeight = null;
	});

	accordionButtons.forEach(button =>
	{
		button.setAttribute('aria-expanded', false);
		const icon = button.querySelector('[data-accordion-icon]');
		if (icon)
		{
			icon.classList.remove('expanded');
		}
	});
}


/**
 * Updates the menu based on the current url
 */
export function update_menu()
{
	//Update the menu aria-current page based on urls
	let url = window.location.href;

	//Remove the old current page attributes
	let current_page = $('.nav li.current-menu-item');
	current_page.removeClass('current-menu-item').find('a').attr('aria-current', '');

	//Find the new current page and add classes
	let active_items = $('.nav').find('a[href="' + url + '"]');
	active_items.each(function ()
	{
		$(this).attr('aria-current', 'page');
		$(this).parent().addClass('current-menu-item');
	});
}

/**
 * Sets up a click event
 */
export function setup_contactmenu_trigger()
{
	const contactMenuTrigger = document.querySelector('.menu-trigger--contact');

	if (!contactMenuTrigger) return;

	contactMenuTrigger.addEventListener('click', function (e)
	{
		e.preventDefault();
		const body = document.querySelector('body');
		const mainMenuTrigger = document.querySelector('.menu-trigger');

		//close main mobile menu
		if (body.classList.contains('menu-active'))
		{
			body.classList.remove('menu-active');
			mainMenuTrigger.innerHTML = 'Menu';
		}

		// toggle contact mobile menu
		if (body.classList.contains('contact-menu-active'))
		{
			body.classList.remove('contact-menu-active');
		} else
		{
			body.classList.add('contact-menu-active');
		}
	});
}



// WEBPACK FOOTER //
// ./scripts/modules/menu.js